// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__37kSK","col":"styles_col__2yFEc","fulfillmentStatus":"styles_fulfillmentStatus__2bjyw","emailCol":"styles_emailCol__2aNQI"};